import React, { useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useLanguageStore } from "@stores/language";

export const I18nProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const language = useLanguageStore((s) => s.language);

    useEffect(() => {
        if (i18n.language !== language) {
            i18n.changeLanguage(language);
        }
        const dir = language === "ur" || language === "ar-AE" ? "rtl" : "ltr";
        document.documentElement.setAttribute("dir", dir);
        document.documentElement.setAttribute("lang", language);
    }, [language]);

    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
